import React, { useState } from "react";

import SavingsIcon from "@mui/icons-material/Savings";

import PercentIcon from "@mui/icons-material/Percent";

import DescriptionIcon from "@mui/icons-material/Description";

import LocalMallIcon from "@mui/icons-material/LocalMall";

import { budgetPlanningTrackerStyle } from "../css/styles/componentStyles";

import SyncAltIcon from "@mui/icons-material/SyncAlt";

import AddIcon from "@mui/icons-material/Add";

import useMockLoading from "../hooks/useMockLoading";
import { BudgetTrackerSkeleton } from "./skeletons/DashboardSkeleton";


import "../css/classes/index.css";
import "../css/classes/budgetPlanningTracker.css";

import AddProductSidebar from "./addProduct/AddProductSidebar";



export default function BudgetPlanningTracker({ refreshApi, loading }) {

  const [budgetItems] = useState([

    {

      id: "expenses",

      title: "Expenses",

      percentage: 55.1,

      icon: <LocalMallIcon size={24} style={{ color: "#d10000" }} />,

      color: "#d10000",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "bills",

      title: "Bills",

      percentage: 1.6,

      icon: <DescriptionIcon size={24} style={{ color: "#00a0c6" }} />,

      color: "#00a0c6",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "debts",

      title: "Debts",

      percentage: 8.0,

      icon: <PercentIcon size={24} style={{ color: "#0066cc" }} />,

      color: "#0066cc",

      bgColor: "#fff",

      textColor: "#333",

    },

    {

      id: "savings",

      title: "Savings",

      percentage: 35.3,

      icon: <SavingsIcon size={24} style={{ color: "#9c27b0" }} />,

      color: "#9c27b0",

      bgColor: "#fff",

      textColor: "#333",

    },

  ]);



  const remainingPercentage = 0.0;

  const mockLoading = useMockLoading([loading], 650);

  if (mockLoading) {
    return <BudgetTrackerSkeleton />;
  }

  return (

    <div style={{ padding: "0 90px", margin: 0, width: "100%" }}>

      <div

        className="row "

        style={{

          display: "flex",

          justifyContent: "space-between",

          flexWrap: "wrap",

          alignItems: "stretch",

        }}

      >

        <div className="col-12" style={{ marginBottom: "12px" }}></div>



        <div className="custom-col-md-2 col-6" style={{ marginBottom: "6px" }}>

          <div

            className="card "

            style={{

              background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",

              color: "#fff",

              border: "1px solid rgba(226, 232, 240, 0.8)",

              borderRadius: "16px",

              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

              cursor: "pointer",

              height: "100%",

              boxShadow: "none",

            }}

            onMouseEnter={(e) => {

              e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";

            }}

            onMouseLeave={(e) => {

              e.currentTarget.style.borderColor = "rgba(226, 232, 240, 0.8)";

            }}

          >

            <div

              className="card-body"

              style={{ padding: "16px", textAlign: "left", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}

            >

              <div

                style={{

                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "flex-start",

                  width: "100%",

                }}

              >

                <div style={{ textAlign: "left" }}>

                  <h5

                    style={{

                      fontSize: "12px",

                      fontWeight: "600",

                      color: "rgba(255, 255, 255, 0.7)",

                      marginBottom: "0",

                      textTransform: "uppercase",

                      letterSpacing: "0.5px"

                    }}

                  >

                    Budget Planning (%)

                  </h5>

                  <h3

                    style={{

                      color: "#10b981",

                      fontWeight: "700",

                      margin: "8px 0 4px 0",

                      fontSize: "26px",

                      fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',

                    }}

                  >

                    {remainingPercentage.toFixed(1)}%

                  </h3>

                  <p

                    style={{

                      color: "rgba(255, 255, 255, 0.5)",

                      marginBottom: "0",

                      fontSize: "11px",

                      fontWeight: "500"

                    }}

                  >

                    To be Allocated

                  </p>

                </div>

                <div

                  style={{

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    width: "36px",

                    height: "36px",

                    borderRadius: "10px",

                    background: "rgba(255, 255, 255, 0.1)",

                  }}

                >

                  <SyncAltIcon style={{ color: "#fff", fontSize: "16px" }} />

                </div>

              </div>

            </div>

          </div>

        </div>



        <div style={{ width: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="hide-custom">

          <AddIcon style={{ color: "#94a3b8", fontSize: "16px" }} />

        </div>





        {budgetItems.map((item, index) => (

          <React.Fragment key={item.id}>

            <div

              className="custom-col-md-2 col-6"

              style={{ marginBottom: "6px" }}

            >

              <div

                className="card budget-planning-tracker-card"

                style={{

                  boxShadow: "none",

                  border: "1px solid rgba(226, 232, 240, 0.8)",

                  borderRadius: "16px",

                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

                  cursor: "pointer",

                  height: "100%",

                  backgroundColor: "#ffffff",

                }}

                onMouseEnter={(e) => {

                  e.currentTarget.style.borderColor = `${item.color}60`;

                  e.currentTarget.style.background = "#f8fafc";

                }}

                onMouseLeave={(e) => {

                  e.currentTarget.style.borderColor = "rgba(226, 232, 240, 0.8)";

                  e.currentTarget.style.background = "#ffffff";

                }}

              >

                <div

                  className="card-body"

                  style={{ padding: "16px", textAlign: "left", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}

                >

                  <div

                    style={{

                      display: "flex",

                      alignItems: "center",

                      gap: "12px",

                      marginBottom: "12px",

                    }}

                  >

                    <div

                      style={{

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        width: "40px",

                        height: "40px",

                        borderRadius: "10px",

                        background: `${item.color}15`,

                      }}

                    >

                      {React.cloneElement(item.icon, { style: { color: item.color, fontSize: "20px" } })}

                    </div>

                    <h6

                      style={{

                        fontSize: "13px",

                        fontWeight: "600",

                        color: "#64748b",

                        margin: 0,

                      }}

                    >

                      {item.title}

                    </h6>

                  </div>

                  <div>

                    <h5

                      style={{

                        fontWeight: "700",

                        marginBottom: "2px",

                        fontSize: "20px",

                        color: "#1e293b",

                        fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',

                      }}

                    >

                      {item.percentage.toFixed(1)}%

                    </h5>

                    <p

                      style={{

                        fontSize: "11px",

                        marginBottom: "0",

                        color: "#94a3b8",

                        fontWeight: "500"

                      }}

                    >

                      of your income

                    </p>

                  </div>

                </div>

              </div>

            </div>



            {index !== budgetItems.length - 1 && (

              <div style={{ width: "20px", display: "flex", alignItems: "center", justifyContent: "center" }} className="hide-custom">

                <AddIcon style={{ color: "#94a3b8", fontSize: "16px" }} />

              </div>

            )}



          </React.Fragment>

        ))}



      </div>



    </div>

  );

}
